<template>
  <div>
    <div class="table-responsive">
      <table class="table table-sm table-tp table-striped table-middle fs-sm">
        <thead>
          <tr>
            <th v-if="$root.user.isAdmin" class="th-shrink" />
            <th />
            <th class="text-right bg-white">Od - do</th>
            <th class="text-right bg-white">Vodné (m3)</th>
            <th class="text-right bg-white">Stočné (m3)</th>
            <th class="text-right bg-white">Zrážky (m3)</th>
            <th class="text-right bg-white">Celková cena (€ bez dph)</th>
            <th class="text-right bg-white">Poznámka</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in data" :key="item.id">
            <td v-if="$root.user.isAdmin">
              <b-dropdown variant="link" no-caret class="btn-p-0">
                <template slot="button-content">
                  <b-icon icon="text-indent-left" scale="1.25x" />
                </template>
                <b-dropdown-item @click.prevent="edit(item.id)">
                  <b-icon icon="pencil-square" class="mr-1" />
                  Upraviť
                </b-dropdown-item>
                <b-dropdown-item
                  class="text-danger"
                  @click.prevent="remove(item.id)"
                >
                  <b-icon icon="trash" class="mr-1" />
                  Vymazať
                </b-dropdown-item>
              </b-dropdown>
            </td>
            <td class="text-nowrap font-weight-bold">
              {{ item.reportDate | formatMonths }}
            </td>
            <td class="text-right">
              <template v-if="item.dateFrom || item.dateTo">
                {{ item.dateFrom | formatDate }} -
                {{ item.dateTo | formatDate }}
              </template>
              <template v-else> - </template>
            </td>
            <td class="text-right">
              <template v-if="item.water != null">
                {{ item.water | formatNumber(2) }}
              </template>
              <template v-else> - </template>
            </td>
            <td class="text-right">
              <template v-if="item.sewerage != null">
                {{ item.sewerage | formatNumber(2) }}
              </template>
              <template v-else> - </template>
            </td>
            <td class="text-right">
              <template v-if="item.rainfall != null">
                {{ item.rainfall | formatNumber(2) }}
              </template>
              <template v-else> - </template>
            </td>
            <td class="text-right">
              <template v-if="item.totalPrice != null">
                {{ item.totalPrice | formatNumber(2) }}
              </template>
              <template v-else> - </template>
            </td>
            <td class="text-right">
              <template v-if="item.note">
                {{ item.note }}
              </template>
              <template v-else> - </template>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td v-if="$root.user.isAdmin" />
            <td />
            <td />
            <td class="text-right">
              <span class="fs-lg font-weight-bold">{{
                sumWater | formatNumber(2)
              }}</span>
            </td>
            <td class="text-right">
              <span class="fs-lg font-weight-bold">{{
                sumSewerage | formatNumber(2)
              }}</span>
            </td>
            <td class="text-right">
              <span class="fs-lg font-weight-bold">{{
                sumRainfall | formatNumber(2)
              }}</span>
            </td>
            <td class="text-right">
              <span class="fs-lg font-weight-bold">{{
                sumTotalPrice | formatNumber(2)
              }}</span>
            </td>
            <td />
          </tr>
        </tfoot>
      </table>
    </div>
    <water-chart :data="chartData" />
    <hr />
    <div class="mb-5">
      <h4>
        <b-icon icon="pencil" />
        Poznámky
        <transition name="fadeRightShort">
          <b-badge v-if="noteSaved" variant="primary">
            {{ noteSaved }}
          </b-badge>
        </transition>
      </h4>
      <b-form-textarea
        v-if="$root.user.isAdmin"
        v-model="note"
        placeholder="žiadne poznámky (kliknutím pridajte)"
        rows="4"
        @blur="$emit('onNoteChange', note)"
      />
      <div
        v-else
        class="h-auto form-control"
        v-html="note ? $options.filters.nl2br(note) : '-'"
      />
    </div>
  </div>
</template>
<script>
import WaterChart from './Chart'

export default {
  components: {
    WaterChart,
  },
  props: ['chartData', 'data', 'note'],
  data() {
    return {
      noteSaved: '',
    }
  },
  computed: {
    sumWater() {
      return this.data.reduce(function (sum, item) {
        return sum + item.water
      }, 0)
    },
    sumSewerage() {
      return this.data.reduce(function (sum, item) {
        return sum + item.sewerage
      }, 0)
    },
    sumRainfall() {
      return this.data.reduce(function (sum, item) {
        return sum + item.rainfall
      }, 0)
    },
    sumTotalPrice() {
      return this.data.reduce(function (sum, item) {
        return sum + item.totalPrice
      }, 0)
    },
  },
  methods: {
    edit(id) {
      this.$root.$emit('reports.openConsumerModal', { id: id })
    },
    remove(id) {
      this.$parent.$parent.remove(id)
    },
  },
}
</script>
